import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { addCompanyPost, setCompanyPosts } from './companyPostsSlice';
import type { UndecoratedPost } from '@flemingmetrics/api-client';
import { mapToKey } from '@/utils/arrays';

type PostsState = {
  byId: Record<string, UndecoratedPost>;
};

const initialState: PostsState = { byId: {} };

export const postsSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {
    addPost: (state, action: PayloadAction<UndecoratedPost>) => {
      return getNextState(state, [action.payload]);
    },
    setPosts: (state, action: PayloadAction<UndecoratedPost[]>) => {
      return getNextState(state, action.payload);
    },
    deletePost: (state, action: PayloadAction<{ postId: number }>) => {
      const byId = { ...state.byId };
      delete byId[`${action.payload}`];
      return { byId };
    },
    deletePosts: (state, action: PayloadAction<{ postIds: number[] }>) => {
      const byId = { ...state.byId };
      action.payload.postIds.forEach((id) => {
        delete byId[`${id}`];
      });
      return { byId };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addCompanyPost, (state, action) => {
      return getNextState(state, [action.payload.post]);
    });
    builder.addCase(setCompanyPosts, (state, action) => {
      return getNextState(state, mapToKey(action.payload, 'post'));
    });
  },
});

function getNextState(state: PostsState, posts: UndecoratedPost[]) {
  const byId = { ...state.byId };
  posts.forEach((p) => {
    byId[p.id] = p;
  });
  return { byId };
}

export const { addPost, setPosts, deletePost, deletePosts } =
  postsSlice.actions;

export default postsSlice.reducer;
